import React from 'react';
import { Users, Settings, Zap, ShieldOff } from 'lucide-react';
import { useTranslations } from '../hooks/useTranslations';
export function ValueProposition() {
  const {
    t
  } = useTranslations();
  return <section id="about" className="pt-4 pb-10 bg-gradient-to-b from-white to-[#f5fdf8] overflow-hidden" data-id="element-453">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-454">
        {/* Top Split Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-6" data-id="element-455">
          {/* Left Image with Badges */}
          <div className="relative" data-id="element-456">
            <div className="rounded-2xl overflow-hidden shadow-2xl relative z-10" data-id="element-457">
              <img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&q=80&w=1000" alt="Business owners discussing funding" className="w-full h-auto object-cover aspect-[4/3]" data-id="element-458" />
            </div>

            {/* Floating Badges */}
            <div className="absolute top-10 left-4 bg-white px-4 py-3 rounded-xl shadow-lg border border-gray-100 z-20" data-id="element-459">
              <p className="text-[10px] text-gray-500 uppercase font-semibold tracking-wider mb-1" data-id="element-460">
                RESTAURANT OWNER
              </p>
              <p className="text-sm font-bold text-gray-900" data-id="element-461">
                $250,000 Approved
              </p>
            </div>

            <div className="absolute bottom-16 left-4 bg-white px-4 py-3 rounded-xl shadow-lg border border-gray-100 z-20" data-id="element-462">
              <p className="text-[10px] text-gray-500 uppercase font-semibold tracking-wider mb-1" data-id="element-463">
                WORKING CAPITAL
              </p>
              <p className="text-sm font-bold text-gray-900" data-id="element-464">$120,000 Sent</p>
            </div>

            <div className="absolute bottom-10 right-4 bg-white px-4 py-3 rounded-xl shadow-lg border border-gray-100 z-20" data-id="element-465">
              <p className="text-[10px] text-gray-500 uppercase font-semibold tracking-wider mb-1" data-id="element-466">
                NEW LLC
              </p>
              <p className="text-sm font-bold text-gray-900" data-id="element-467">$75,000 Funded</p>
            </div>
          </div>

          {/* Right Text Content */}
          <div className="space-y-6 text-center lg:text-left" data-id="element-468">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight" data-id="element-469">
              {t('value.title')}
            </h2>
          </div>
        </div>

        {/* Bottom Features Row - Compact horizontal layout */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-470">
          <div className="flex items-center gap-4 py-3" data-id="element-471">
            <div className="w-10 h-10 rounded-lg bg-blue-500 flex items-center justify-center flex-shrink-0" data-id="element-472">
              <Users className="w-5 h-5 text-white" data-id="element-473" />
            </div>
            <div data-id="element-474">
              <h3 className="text-sm font-bold text-gray-900" data-id="element-475">
                {t('value.feature1.title')}
              </h3>
              <p className="text-xs text-gray-500 leading-relaxed" data-id="element-476">
                {t('value.feature1.desc')}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-4 py-3" data-id="element-477">
            <div className="w-10 h-10 rounded-lg bg-orange-500 flex items-center justify-center flex-shrink-0" data-id="element-478">
              <Settings className="w-5 h-5 text-white" data-id="element-479" />
            </div>
            <div data-id="element-480">
              <h3 className="text-sm font-bold text-gray-900" data-id="element-481">
                {t('value.feature2.title')}
              </h3>
              <p className="text-xs text-gray-500 leading-relaxed" data-id="element-482">
                {t('value.feature2.desc')}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-4 py-3" data-id="element-483">
            <div className="w-10 h-10 rounded-lg bg-emerald-500 flex items-center justify-center flex-shrink-0" data-id="element-484">
              <Zap className="w-5 h-5 text-white" data-id="element-485" />
            </div>
            <div data-id="element-486">
              <h3 className="text-sm font-bold text-gray-900" data-id="element-487">
                {t('value.feature3.title')}
              </h3>
              <p className="text-xs text-gray-500 leading-relaxed" data-id="element-488">
                {t('value.feature3.desc')}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-4 py-3" data-id="element-489">
            <div className="w-10 h-10 rounded-lg bg-purple-500 flex items-center justify-center flex-shrink-0" data-id="element-490">
              <ShieldOff className="w-5 h-5 text-white" data-id="element-491" />
            </div>
            <div data-id="element-492">
              <h3 className="text-sm font-bold text-gray-900" data-id="element-493">
                {t('value.feature4.title')}
              </h3>
              <p className="text-xs text-gray-500 leading-relaxed" data-id="element-494">
                {t('value.feature4.desc')}
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mt-8" data-id="element-495">
          <a href="https://form.jotform.com/260402880146048" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center text-sm font-bold px-8 py-3.5 rounded-lg text-white bg-[#00E676] hover:bg-[#00d169] shadow-lg shadow-green-200/50 hover:shadow-xl hover:shadow-green-300/50 hover:scale-[1.03] active:scale-[0.98] transition-all duration-300" data-id="element-496">
            {t('value.cta')}
          </a>
        </div>
      </div>
    </section>;
}